import React, { useMemo, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import styled from '@emotion/styled';

import RecordImageModal from './modals/RecordImageModal';
import RecordVideoModal from './modals/RecordVideoModal';
import FeedModalWrapper from './modals/FeedModalWrapper';

import { setSubActiveReduxModal } from './ducks/feedActions';

const MainContainer = styled('main')``;

const SubModalHandler = () => {
  const dispatch = useDispatch();
  const activeSubModal = useSelector((state) => state.feed.data.activeSubModal);

  const closeSubModal = useCallback(() => dispatch(setSubActiveReduxModal('')), [dispatch]);

  const modalConfigs = useMemo(() => ({
    'record-video-modal': { content: RecordVideoModal },
    'record-image-modal': { content: RecordImageModal },
  }), []);

  const contentStyles = useMemo(() => ({
    backgroundColor: '#222222',
  }), []);

  const Content = useMemo(() => {
    if (!activeSubModal || !modalConfigs[activeSubModal]) return null;
    return modalConfigs[activeSubModal].content;
  }, [activeSubModal, modalConfigs]);

  if (!Content) return null;

  return (
    <MainContainer>
      <FeedModalWrapper
        isOpen={!!activeSubModal}
        onRequestClose={closeSubModal}
        modalName={activeSubModal}
        contentStyles={contentStyles}
      >
        <Content onRequestClose={closeSubModal} />
      </FeedModalWrapper>
    </MainContainer>
  );
};

export default SubModalHandler;
